import { useState, useEffect } from "react";
import {
  Group,
  Container,
  Grid,
  TextInput,
  Center,
  Loader,
  Button,
  Select,
  Stack,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useLocation } from "wouter";
import { getSingleUser, updateUser } from "../api";
import { useStore } from "../store";
import { useTranslation } from "react-i18next";

export default function UserEdit({ params }) {
  const [user, setUser] = useState(null);
  const [, setLocation] = useLocation();
  const profile = useStore((state) => state.profile);
  const { t } = useTranslation("Users");

  useEffect(() => {
    getSingleUser(params.id).then((data) => {
      setUser(data);
      form.setValues({
        firstName: data.firstName,
        lastName: data.lastName,
        emailAddress: data.emailAddress,
        role: data.role,
      });
    });
  }, []);

  const updateUserHandler = (data) => {
    updateUser(params.id, data).then((response) => {
      setLocation(`/users/${response.id}`);
    });
  };

  const form = useForm({
    mode: "uncontrolled",
  });

  if (!user)
    return (
      <Center mt="xl">
        <Loader size="xl" />
      </Center>
    );

  const allRoles = [
    "GlobalAdmin",
    "MarketplacePartner",
    "TenantOwner",
    "TenantAdmin",
    "TenantUser",
  ];

  let availableRoles = [];
  switch (profile.role) {
    case "GlobalAdmin":
      availableRoles = allRoles;
      break;
    case "MarketplacePartner":
      availableRoles = ["MarketplacePartner"];
      break;
    case "TenantOwner":
      availableRoles = ["TenantOwner", "TenantAdmin", "TenantUser"];
      break;
    case "TenantAdmin":
      availableRoles = ["TenantAdmin", "TenantUser"];
      break;
    case "TenantUser":
      availableRoles = ["TenantUser"];
      break;
  }

  return (
    <Container size="xs">
      <Grid justify="space-between" gap="2px">
        <Grid.Col span={12}>
          <form onSubmit={form.onSubmit(updateUserHandler)}>
            <Stack>
              <TextInput
                {...form.getInputProps("firstName")}
                key={form.key("firstName")}
                label={t("first_name")}
              />
              <TextInput
                {...form.getInputProps("lastName")}
                key={form.key("lastName")}
                label={t("last_name")}
              />
              <TextInput
                {...form.getInputProps("emailAddress")}
                key={form.key("emailAddress")}
                label={t("email")}
              />
              <Select
                {...form.getInputProps("role")}
                key={form.key("role")}
                label={t("role")}
                data={availableRoles}
              />
              <Group justify="flex-end">
                <Button type="submit" mt="md">
                  {t("save")}
                </Button>
              </Group>
            </Stack>
          </form>
        </Grid.Col>
      </Grid>
    </Container>
  );
}
